const applicationRoute = '/mortgage/application/';
const postAppRoute = '/mortgage/postapp/';
const postapp = '/postapp/';
const consumerPostApp = postapp;
const user = '/user/';
const oao = '/oao/';
const ola = '/ola/';
const OaoPostapp = postapp;
const auto = '/ola-consumer/';
const loandetails = '/ola-loan-details';

export const OAORoutingUrl = {
  OAO: '/oao/'
};
export const RoutingUrl = {
  Login: user + 'login',
  OLARegistration: user + 'registration',
  ForgetPassword: user + 'forgetpassword',
  PageNotFound: 'error/404',
  PersonalInfo: applicationRoute + 'personal',

  /* Post App */
  PostApp_Overview: postAppRoute + 'overview',
  PostApp_loan: postAppRoute + 'loan',
  ConsumerPostApp_Overview: consumerPostApp + 'overview',

  /* Consumer Post App*/
  Dashboard: '/consumer/dashboard',
  OverView: consumerPostApp + 'overview/',
  Tasks: consumerPostApp + 'tasks',
  Registration: '/signup',
  Signin: '/login',

  /* OAO application */
  OaoEligibility: oao + 'eligibility',
  OaoApplication: 'oao-application-fields',
  OaoYouthApplication: 'oao-application-fields-youth',
  OaoBusinessApplication: 'oao-business-info',
  OaoMembership: oao + 'membership',
  OaoDashboard: oao + 'dashboard',
  OaoPersonalInfo: oao + 'oao-application-fields',
  OaoIdentity: oao + 'identity',
  OaoAccountService: 'accountsandservices',
  /* oao post app */

  OAO: {
    Membership: oao + 'membership',
    Tasks: OaoPostapp + 'tasks',
    Overview: OaoPostapp + 'overview'
  },
  OLA: {
    LoanType: ola + 'ola-consumer-loan-type',
    Loandetails: ola + 'ola-loan-details',
    OlaEligibility: ola + 'eligibility',
    Auto: auto + 'auto' + loandetails,
    CreditCard: auto + 'cc' + loandetails,
    Personal: auto + 'personal' + loandetails,
    PersonalLineOfCredit: auto + 'personal-line-of-credit' + loandetails,
    Secured: auto + 'secured' + loandetails,
    UsedVehicle: auto + 'usedvehicle' + loandetails,
    NewVehicle: auto + 'newvehicle' + loandetails,
    BoatAndRV: auto + 'boatandrv' + loandetails,
    Motorcycle: auto + 'motorcycle' + loandetails,
    SignatureLoan: auto + 'signatureloan' + loandetails,
    HolidayLoan: auto + 'holidayloan' + loandetails,
    VacationLoan: auto + 'vacationloan' + loandetails,
    ApplianceLoan: auto + 'applianceloan' + loandetails,
    AutoSmart: auto + 'autosmart' + '/eligibility'
  }
};
